import Container from "@/components/ui/container";

export default function SupportPage() {
	return (
		<Container className="py-12">
			<h1 className="text-3xl font-bold text-gray-900">Support</h1>
			<p className="mt-4 text-gray-600">Support page content coming soon...</p>
		</Container>
	);
}
